import { render } from "./PaymentProvidersView.vue?vue&type=template&id=32f0dd56&scoped=true&ts=true"
import script from "./PaymentProvidersView.vue?vue&type=script&lang=ts"
export * from "./PaymentProvidersView.vue?vue&type=script&lang=ts"

import "./PaymentProvidersView.vue?vue&type=style&index=0&id=32f0dd56&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32f0dd56"]])

export default __exports__